import {
  applicationRejectedJobPath,
  isApplicationRejectedNotification,
  normalizeNotificationActionHref,
  notificationOpenPath as rejectionBellOpenPath,
} from "./rejectionNotification";
import { isProfileSetupRequiredNotification } from "./applicantProfileNotification";
import {
  hiringInvitesCompletedOpenPath,
  isHiringInvitesCompletedNotification,
} from "./hiringInviteNotification";

/** Bell dropdown row tap. */
export function notificationBellOpenPath(notification, role) {
  if (isProfileSetupRequiredNotification(notification)) {
    return "/applicant-profile";
  }
  if (isHiringInvitesCompletedNotification(notification)) {
    return hiringInvitesCompletedOpenPath(notification, role);
  }
  return rejectionBellOpenPath(notification, role);
}

/** Full notifications page row tap. */
export function notificationPageOpenPath(notification, role) {
  if (isApplicationRejectedNotification(notification)) {
    return applicationRejectedJobPath(notification);
  }
  if (isProfileSetupRequiredNotification(notification)) {
    return "/applicant-profile";
  }
  if (isHiringInvitesCompletedNotification(notification)) {
    return hiringInvitesCompletedOpenPath(notification, role);
  }
  return normalizeNotificationActionHref(notification?.actionHref, role);
}
